// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__eU8A4","wrapper":"ErrorBoundary_wrapper__miQ8O"};